import { PrimaryButton, SecondaryButton, ButtonProps } from '../../button';

export type ModalButtonPairProps = {
  isRightAligned?: boolean;
} & ModalButtons;

export type ModalButtons = {
  primaryButton?: ButtonProps;
  secondaryButton?: ButtonProps;
};

export const ModalButtonPair = ({
  isRightAligned,
  primaryButton,
  secondaryButton,
}: ModalButtonPairProps): JSX.Element => {
  const containerClassName = isRightAligned ? 'core-modal-v2-button-pair__container--right-aligned' : '';
  return (
    <div className={containerClassName}>
      {secondaryButton && <SecondaryButton {...secondaryButton} />}
      {primaryButton && <PrimaryButton className="core-modal-v2-button-pair__primary-button" {...primaryButton} />}
    </div>
  );
};
